__webpack_require__.p = "/mailbox-data-next/referrals/";